import React from "react";

import "./App.css";
import HomePage from "./pages/HomePage";
import SkillsPage from "./pages/SkillsPage";
import MainNavigation from "./components/Navigation/MainNavigation";
import WorkPage from "./pages/WorkPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <React.Fragment>
      <MainNavigation />
      <main>
        <HomePage />
        <SkillsPage />
        <WorkPage />
        <ProjectsPage />
        <ContactPage />
      </main>
    </React.Fragment>
  );
}

export default App;
